import { render, staticRenderFns } from "./IVTypeTab.vue?vue&type=template&id=1ceb913e&scoped=true&"
import script from "./IVTypeTab.vue?vue&type=script&lang=js&"
export * from "./IVTypeTab.vue?vue&type=script&lang=js&"
import style0 from "./IVTypeTab.vue?vue&type=style&index=0&id=1ceb913e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ceb913e",
  null
  
)

export default component.exports